import React from 'react';
import { FieldDescription } from '../base-controls/FieldDescription';
import { FieldError } from '../base-controls/FieldError';
import clsx from 'clsx';
import { FieldLabelWithHtml } from '../base-controls/FieldLabelWithHtml';
import { ButtonGroup, type ButtonGroupProps } from '../base-controls/ButtonGroup';
import type { BaseFieldProps } from '~/shared/components/types';

export interface ButtonGroupFieldProps<T> extends Omit<ButtonGroupProps<T>, 'className'>, BaseFieldProps {
	description?: string;
	className?: string;
	required?: boolean;
	hideLabel?: boolean;
	buttonProperties?: {
		className?: string;
	};
}

export function ButtonGroupField<T>({ label, description, className, required, hideLabel, buttonProperties, ...props }: ButtonGroupFieldProps<T>) {
	return (
		<div className={clsx(className, 'flex flex-col gap-1')}>
			{!hideLabel ? <FieldLabelWithHtml className="mb-3" label={label} required={required} /> : null}
			<div className="flex flex-wrap gap-2">
				<ButtonGroup {...props} {...buttonProperties} />
			</div>

			{description && <FieldDescription>{description}</FieldDescription>}
			{props.error && <FieldError {...props.error} />}
		</div>
	);
}
